import React, { useContext, useMemo, useState } from 'react';
import { Portal } from 'react-portal';
import { analyticService } from 'global/services';
// TODO!!!! Перенесести его в отдельный компонент
import { NextOverlay } from 'app/views/Menu/Menu/components/CustomIngredientsSelectDishRow/Mobile/overlay/nextOverlay';
import { LocationContext } from 'app/containers/LocationProvider';
import { getCityMetaByLocationKey } from 'app/const/location';
import { MobileCategoriesSlider } from './components/MobileCategoriesSlider';
import MobileDeliveryDateSelectPopup from './components/MobileDeliveryDateSelectPopup/mobileDeliveryDateSelectPopup';
import { BR1258MobileHeader } from './BR1258/MobileHeaderV2';


export function MobileHeaderWithCategoriesSlider(props: any) {
    const {
        onClickMobileNavigationButton,
        onClickFilters,
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const { location: { pathname } } = window;

    const {
        locationKey,
        mutateAddreessHandler,
        // isLocationDataLoading,
        // locationKey,
    } = useContext(LocationContext);
    const title = useMemo(() => {
        const meta = getCityMetaByLocationKey(locationKey);
        return meta.title;
    }, [locationKey]);

    const isProfile = useMemo<boolean>(
        () => {
            const regex = /^\/(profile)(\/.*)?$/;
            return regex.test(pathname);
        },
        [pathname],
    );

    const isDeliveryMenu = useMemo(() => {
        const regex = /^\/(app\/delivery)(\/.*)?$/;
        return regex.test(pathname);
    }, [pathname]);


    const handleOpenPopup = () => {
        setIsOpen(true);
        analyticService
            .push({ eventName: 'Filter_Open_City', eventAction: 'Open', eventLabel: 'City' })
            .push({ eventName: 'Filter_Open_Week', eventAction: 'Open', eventLabel: 'Week' });
    };

    return (
        <>
            <BR1258MobileHeader
                onClickMobileNavigationButton={onClickMobileNavigationButton}
                handleOpenPopup={handleOpenPopup}
                title={title}
                onClickFilters={onClickFilters}
                isProfile={isProfile}
                isDeliveryMenu={isDeliveryMenu}
            />
            {!isProfile && <MobileCategoriesSlider />}
            {/* POPUP */}
            <Portal>
                <NextOverlay
                    isOpen={isOpen}
                    handleClose={() => { setIsOpen(false); }}
                >
                    {/* GRAND-TODO */}
                    <MobileDeliveryDateSelectPopup
                        setIsOpen={setIsOpen}
                        mutateAddreessHandler={mutateAddreessHandler}
                    />
                </NextOverlay>
            </Portal>
        </>
    );
}
